module.exports = __webpack_public_path__ + "static/other/starPilotAll.cf671a48.json";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qci/atlas/starPilotAll.json
// module id = 190
// module chunks = 0